import { render } from "./login.vue?vue&type=template&id=2b324090"
const script = {}

import exportComponent from "D:\\All Sites\\Trial Sites\\vue_13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__